"use strict";
'use strict';

var avatar = require('./avatar.cjs');



exports.Context = avatar.AvatarContext;
exports.Fallback = avatar.AvatarFallback;
exports.Icon = avatar.AvatarIcon;
exports.Image = avatar.AvatarImage;
exports.PropsProvider = avatar.AvatarPropsProvider;
exports.Root = avatar.AvatarRoot;
exports.RootProvider = avatar.AvatarRootProvider;
